export default __webpack_public_path__ + "static/media/SM.0cfc8b5e.svg";